
export const system = {
    namespaced: true,
    state: {
        loaded: false,
        settings:{},
        title:'hossain',
        menuOpen: false,
        lang: localStorage.getItem('language') || 'bn',
    },
    actions: {},
    mutations: {
        setSettings(state, setting) {
            state.settings = setting;
            state.loaded = true;
        },
        setLanguage(state, val) {
            localStorage.setItem('language', val);
            state.lang = val;
        }
    },
    getters: {
        // settings: state => state.settings,
        // title: state => state.title,
    },
};